export default __webpack_public_path__ + "e9351159f742170d3fceb5f5238bbf9c.svg";